import * as z from "zod/v4";

export const getValidReturnTrackingTriggers = {
  name: "getValidReturnTrackingTriggers" as const,
  input: z.object({}), // No input needed, uses team from context
  output: z.object({
    triggers: z.array(
      z.object({
        key: z.string(), // ReturnTrackingTriggerKey
        displayName: z.string(),
      }),
    ),
  }),
};
